import React from 'react';
import {
  Users, DollarSign, FileText, TrendingUp, Calendar, Filter, Download, RefreshCw, CheckCircle, XCircle, Clock, Search, Mail, Phone, Building, CreditCard, Percent, AlertTriangle, Check, X, Edit2, Save, Wallet, Send, ArrowRight, Banknote, Bell, Trash2, Eye
} from 'lucide-react';
import { useSuperAdminContext } from '../SuperAdminContext';

export default function NotificationsTab() {
  const ctx = useSuperAdminContext();
  const { activeTab, fetchNotifications, handleDeleteNotification, handleMarkAllRead, handleMarkNotificationRead, notifications, selectedNotification, setSelectedNotification, unreadCount } = ctx;

  return (
    <>
            {activeTab === 'notifications' && (
              <div className="notifications-content" data-testid="notifications-tab">
                <div className="section-header">
                  <h2><Bell size={24} /> System Notifications</h2>
                  <div className="header-actions">
                    {unreadCount > 0 && (
                      <button className="btn-secondary" onClick={handleMarkAllRead}>
                        <CheckCircle size={16} /> Mark All Read
                      </button>
                    )}
                    <button className="btn-secondary" onClick={fetchNotifications}>
                      <RefreshCw size={16} /> Refresh
                    </button>
                  </div>
                </div>

                <p className="notifications-description">
                  Email notifications and system alerts are stored here for your review. 
                  This includes agent registrations, payment updates, and scheduled reports.
                </p>

                <div className="notifications-layout">
                  {/* Notifications List */}
                  <div className="notifications-list">
                    {notifications.length === 0 ? (
                      <div className="empty-state">
                        <Bell size={48} color="rgba(228, 230, 235, 0.3)" />
                        <p>No notifications yet</p>
                        <p className="empty-hint">System notifications will appear here</p>
                      </div>
                    ) : (
                      notifications.map((notif) => (
                        <div 
                          key={notif.id} 
                          className={`notification-item ${notif.read ? 'read' : 'unread'} ${selectedNotification?.id === notif.id ? 'selected' : ''}`}
                          onClick={() => {
                            setSelectedNotification(notif);
                            if (!notif.read) handleMarkNotificationRead(notif.id);
                          }}
                        >
                          <div className="notification-icon">
                            <Mail size={16} />
                          </div>
                          <div className="notification-content">
                            <div className="notification-subject">{notif.subject}</div>
                            <div className="notification-meta">
                              <span className="notification-to">To: {notif.to}</span>
                              <span className="notification-time">
                                {new Date(notif.timestamp).toLocaleString()}
                              </span>
                            </div>
                          </div>
                          {!notif.read && <div className="unread-dot"></div>}
                        </div>
                      ))
                    )}
                  </div>

                  {/* Notification Detail */}
                  {selectedNotification && (
                    <div className="notification-detail">
                      <div className="detail-header">
                        <h3>{selectedNotification.subject}</h3>
                        <button 
                          className="btn-icon"
                          onClick={() => handleDeleteNotification(selectedNotification.id)}
                          title="Delete notification"
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                      <div className="detail-meta">
                        <p><strong>To:</strong> {selectedNotification.to}</p>
                        <p><strong>Date:</strong> {new Date(selectedNotification.timestamp).toLocaleString()}</p>
                        <p><strong>Status:</strong> <span className={`status-badge ${selectedNotification.read ? 'read' : 'unread'}`}>{selectedNotification.read ? 'Read' : 'Unread'}</span></p>
                      </div>
                      <div className="detail-body">
                        {selectedNotification.body_html ? (
                          <div dangerouslySetInnerHTML={{ __html: selectedNotification.body_html }} />
                        ) : (
                          <pre>{selectedNotification.body_text}</pre>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
    </>
  );
}
